<template>
    <div id="#App" class="n8-gallery-app flex flex-column justify-between">
      <div>
        <navigation-bar/>
        <div v-if="user.name !== '' && user.phone_nr !== ''" class="user-chip p2 px3 col-12 flex align-middle flex-end border-box">
          <img class="mr1 user-chip__icon" src="./assets/user-icon.svg">
          <p class="semibold">{{user.user_name}}, ({{user.phone_nr}})</p></div>
        <router-view></router-view>
      </div>
      <footer-comp/>
    </div>
</template>

<script>

// import axios from 'axios';
import { EventBus } from "./event-bus";
import NavigationBar from './components/NavigationBar.vue';
import FooterComp from './components/FooterComp.vue';

export default {
  name: "App",
  data() {
    return {
      session: {
        validation_crypt: '',
        validation_id: '',
        validation_object: '',
      },
      user: {
        name: '',
        phone_nr: '',
        dsgvo: false
      },
      loginStatus: true,
    };
  },
  components: {
    'navigation-bar': NavigationBar,
    'footer-comp': FooterComp
  },

  created: function () {
    console.log('App mounted, checking for Cookies...')
    console.log(this.$cookies.get("session"));
    console.log(this.$cookies.get("user"));

    if(this.$cookies.get("session") !== null){
      console.log('Session Cookie could be found. Recovering Session...')
      this.session = this.$cookies.get("session");
    }
    if(this.$cookies.get("user") !== null){
      console.log('User Cookie could be found. Recovering User...')
      this.user = this.$cookies.get("user");
    }

    EventBus.$on('send_validation', (payload) => {
      console.log('App received Session from Component: ');
      console.log(payload);
      if(this.$cookies.get("session") == null){
        console.log('No Session Cookie set. Setting Cookie now.')
        var session = payload
        this.$cookies.set("session", session)
        this.session = payload
      }
      if(this.$cookies.get("session") !== null){
        if(this.$cookies.get("session").validation_crypt !== payload.validation_crypt){
          console.log('Validation_crypt from payload not the same as from cookie. Updating Cookie with new vliadtion_crypt.')
          var session2 = payload
          this.$cookies.set("session", session2)
          this.session = payload
        }else{
          console.log('Sesssion identical with Cookie. Everything is fine.')
        }
      }
    });

    EventBus.$on('send_user', (payload) => {
      console.log('App received User from Component: ');
      console.log(payload);
      if(this.$cookies.get("user") == null){
        console.log('No User Cookie set. Setting Cookie now.')
        var user = payload
        this.$cookies.set("user", user)
        this.user = payload
      }
      if(this.$cookies.get("user") !== null){
        if(this.$cookies.get("user").phone_nr !== payload.phone_nr){
          console.log('Phone nr from payload not the same as from cookie. Updating Cookie with new phone number.')
          var user2 = payload
          this.$cookies.set("user", user2)
          this.user = payload
        }else{
          console.log('User identical with Cookie. Everything is fine.')
        }
      }
    })

    EventBus.$on('requestSession', () => {
      console.log('Session from APP Requested. Sending Session...')
      EventBus.$emit('sendSession', {
        'session': this.session
      });
    });

    EventBus.$on('requestSession_Component', () => {
      console.log('received Session request from Component')
      if(this.$cookies.get("session") == null){
        console.log('No Sesion availaible. Doing nothing.')
      }else{
        console.log('sending Session to component.')
        EventBus.$emit('sendSession_Component', {
          'session': this.session
        })
      }
    });

    EventBus.$on('requestUser', () => {
      console.log('received User request. Sending User...')
      EventBus.$emit('sendUser', {
        'user': this.user
      });
    })

    EventBus.$on('requestUser_Component', () => {
      console.log('received User request from Component')
      if(this.$cookies.get("user") == null){
        console.log('No User availaible. Doing nothing.')
      }else{
        console.log('sending User to component.')
        EventBus.$emit('sendUser_Component', {
          'user': this.user
        })
      }
    });

  },
  mounted(){
    // console.log('set Test cookie: ');
    // var session = {};
    // this.$cookies.set("user_session", session);
    // console.log(this.$cookies.get("user_session"));
  }
}
</script>

<style lang="scss">
@import './css/styles.scss';
@import './css/index.css';

.n8-gallery-app {
  min-height: 100vh;
  background: var(--paper);
  color: var(--text);
}

.user-chip {
  background: rgba(204, 44, 206, 0.12);
  border-bottom: 1px solid var(--line);
  color: var(--text);
}

.user-chip__icon {
  filter: brightness(0) invert(1);
  opacity: 0.85;
}
</style>
